import { PostcodeService, CustomerService } from '@/common/api.service';
import { 
    SEARCH_POSTCODE,
    SELECT_ADDRESS, 
    SAVE_CUSTOMER_DETAILS, 
    UPDATE_CUSTOMER_DETAILS,
    CUSTOMER_DETAILS_COMPLETE
} from './actions.type';
import { 
    SET_ADDRESSES, 
    SET_ADDRESS, 
    SET_POSTCODE, 
    SET_CUSTOMER_DETAILS
} from './mutations.type';
import router from '../router'

const state = {
    customerDetails: {
        FirstName: '',
        LastName: '',
        EmailAddress: '',
        AddressLine1: '',
        AddressLine2: '',
        AddressLine3: '',
        AddressLine4: '',
        Locality: '',
        Town: '',
        County: '',
        Postcode: '',
        Latitude: '',
        Longitude: '',
        MobileNumber: ''
    },
    addresses: []
};

const getters = {
    lookupAddresses(state){
        return state.addresses;
    },
    customerAddress(state) {
        var { AddressLine1, Locality, Town, County, Postcode } = state.customerDetails;

        if (AddressLine1.length > 0 && Town.length > 0)
            return `${AddressLine1}\n${Locality}\n${Town}\n${County}\n${Postcode.toUpperCase()}`;
        else 
            return '';
    }
}

const actions = {
    [SEARCH_POSTCODE]({commit}, payload) {
        commit(SET_POSTCODE, payload);

        return PostcodeService.get(payload)
            .then(({data}) => {
                commit(SET_ADDRESSES, data)
            }) 
    },
    [SELECT_ADDRESS]({commit}, payload) {
        commit(SET_ADDRESS, payload)
    },
    [UPDATE_CUSTOMER_DETAILS]({ commit }, payload) {
        commit(SET_CUSTOMER_DETAILS, payload)
    },
    [SAVE_CUSTOMER_DETAILS]({ commit, state, getters, dispatch }) {
        return CustomerService.SaveCustomer(state.customerDetails)
            .then(() => {
                dispatch(CUSTOMER_DETAILS_COMPLETE, null, { root: true });
                
                if (getters.TakeCustomerDetailsFirst) {
                    // If ask customer questions first then redirect to products
                    router.push({ name: 'products' })
                } else {
                    // Otherwise we will show complete page
                    router.push({ name: 'Complete' })
                }
            });
    }
}

const mutations = {
    [SET_ADDRESSES] (state, payload) {
        state.addresses = payload.Addresses;

        state.customerDetails.Latitude = payload.Latitude;
        state.customerDetails.Longitude = payload.Longitude;
    },
    [SET_ADDRESS] (state, payload) {
        state.customerDetails.AddressLine1 = payload.Line1;
        state.customerDetails.Locality = payload.Locality;
        state.customerDetails.County = payload.County;
        state.customerDetails.Town = payload.TownOrCity;

        // after setting the address - reset the addresses list
        state.addresses = [];
    },
    [SET_POSTCODE] (state, payload) {
        state.customerDetails.Postcode = payload;
    },
    [SET_CUSTOMER_DETAILS] (state, payload) {
        state.customerDetails.FirstName = payload.FirstName;
        state.customerDetails.LastName = payload.LastName;
        state.customerDetails.EmailAddress = payload.EmailAddress;
        state.customerDetails.MobileNumber = payload.MobileNumber;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};